import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';

const useBannerHomeStyles = createUseStyles((theme: Theme) => {
    return {
        navLink: {
            width: '100%',
            display: 'block',
        },
        bannerImage: {
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
            display: 'block',
        }
    };
});

export default useBannerHomeStyles;